import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { MainContext } from "../App";

function FlowModeSelector({ className = "" }) {
  const { settings, table, flow, setFlow, maxFlow, setMaxFlow } = useContext(MainContext);
  const [flowDropdownOpen, setFlowDropdownOpen] = useState(false);
  const flowDropdownRef = useRef(null);
  const baseFlowsNumber = Math.max(parseInt(settings?.orders?.flows_number || 5), 1);
  const isHorizontalSelector = className.split(" ").includes("in-horizontal-menu");
  const isCategoriesHorizontalEnabled = parseInt(settings?.waiter_app?.categories_menu_type || 0) === 2;
  const isFlowSelectorEnabled =
    (settings?.orders?.enable_flow ?? settings?.waiter_app?.enable_flow) == 1;

  const availableFlows = useMemo(() => {
    if (!table) return [];
    const minFlow = parseInt(table.flow) + 1;
    const maxFlowNumber = Math.max(parseInt(maxFlow || baseFlowsNumber), baseFlowsNumber, minFlow);
    let arr = [];
    for (let i = minFlow; i <= maxFlowNumber; i++) arr.push(i);
    return arr;
  }, [table, maxFlow, baseFlowsNumber]);

  useEffect(() => {
    if (!isFlowSelectorEnabled) return;
    if (availableFlows.length === 0) return;
    if (!availableFlows.includes(parseInt(flow))) setFlow(availableFlows[0]);
  }, [availableFlows, flow, isFlowSelectorEnabled, setFlow]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (flowDropdownRef.current && !flowDropdownRef.current.contains(event.target)) {
        setFlowDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  if (isHorizontalSelector && !isCategoriesHorizontalEnabled) return null;
  if (!isFlowSelectorEnabled || availableFlows.length === 0) return null;

  const handleAddFlow = () => {
    const nextFlow = parseInt(maxFlow || baseFlowsNumber) + 1;
    setMaxFlow(nextFlow);
    setFlow(nextFlow);
    setFlowDropdownOpen(false);
  };

  return (
    <div className={"flow-mode-selector " + className} ref={flowDropdownRef}>
      <button
        type="button"
        className="flow-dropdown-trigger"
        onClick={() => setFlowDropdownOpen(!flowDropdownOpen)}
      >
        <span className="flow-dropdown-trigger-value">{flow}°</span>
        <span className="flow-dropdown-trigger-label">Portata</span>
      </button>
      {flowDropdownOpen && (
        <div className="flow-dropdown-menu">
          {availableFlows.map((f) => (
            <button
              type="button"
              key={f}
              className={parseInt(flow) === f ? "active" : ""}
              onClick={() => {
                setFlow(f);
                setFlowDropdownOpen(false);
              }}
            >
              Portata {f}
            </button>
          ))}
          <button type="button" className="add-flow-btn" onClick={handleAddFlow}>
            Aggiungi portata
          </button>
        </div>
      )}
    </div>
  );
}

export default FlowModeSelector;
